import { Ruler, Scissors, Sparkles } from "lucide-react";

export default function VipBanner() {
  return (
    <section data-testid="vip-banner" className="relative bg-ink text-cream overflow-hidden">
      {/* Soft gold radial */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-[0.08]"
        style={{ background: "radial-gradient(60% 80% at 20% 50%, #C5A059 0%, transparent 60%)" }}
      />
      {/* Top + bottom hairlines */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />
      <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28 lg:py-32">
        <div className="grid lg:grid-cols-[auto_1fr] gap-12 lg:gap-20 items-center">
          {/* Gold Seal */}
          <div className="flex justify-center lg:justify-start">
            <div
              data-testid="vip-seal"
              className="relative w-44 h-44 md:w-52 md:h-52 rounded-full flex items-center justify-center"
              style={{ animation: "fade-up 0.9s ease-out both" }}
            >
              <div className="absolute inset-0 rounded-full border border-gold" />
              <div className="absolute inset-3 rounded-full border border-gold/30" />
              <div className="text-center px-4">
                <div className="text-[10px] uppercase tracking-[0.32em] text-gold/90">Premium</div>
                <div className="font-display text-5xl md:text-6xl text-gold leading-none mt-2">VIP</div>
                <div className="text-[10px] uppercase tracking-[0.32em] text-gold/90 mt-2">Inklusive</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="max-w-3xl">
            <div className="overline text-gold mb-5">
              <span className="gold-line" />Hauseigene Schneiderei
            </div>
            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight text-cream">
              Perfekter Sitz. <span className="italic text-gold">Garantiert.</span>
            </h2>
            <p className="mt-8 text-cream/85 text-lg md:text-xl font-light leading-relaxed max-w-2xl">
              Jedes Kleid wird in unserer eigenen Schneiderei <strong className="text-cream font-medium">kostenlos auf deine Maße angepasst</strong>.
              Länge, Weite, individuelle Details – wir arbeiten so lange, bis es sitzt wie maßgeschneidert.
              <span className="block mt-3 text-cream">Die Miete deckt alles ab.</span>
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-10 max-w-2xl">
              <Pillar icon={<Ruler size={18} className="text-gold" />} title="Maß nehmen" desc="Persönlich vor Ort in unserem Atelier." />
              <Pillar icon={<Scissors size={18} className="text-gold" />} title="Anpassen" desc="Individuelle Schnitt-Anpassungen inklusive." />
              <Pillar icon={<Sparkles size={18} className="text-gold" />} title="Pflege" desc="Professionelle Reinigung im Mietpreis enthalten." />
            </div>

            <div className="mt-10 inline-flex items-center gap-3 text-cream/60 text-xs uppercase tracking-[0.28em]">
              <span className="w-8 h-px bg-gold" />
              Keine versteckten Kosten
              <span className="w-8 h-px bg-gold" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Pillar({ icon, title, desc }) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-cream text-sm uppercase tracking-widest">{title}</span>
      </div>
      <p className="text-cream/65 text-sm leading-relaxed">{desc}</p>
    </div>
  );
}
